export const COACH_TITRE = 'Coach Sportif'

export const normalizeCoachTitre = (value) => {
  const trimmed = String(value || '').trim()
  if (!trimmed) return COACH_TITRE
  if (/^coaching\s+sportif$/i.test(trimmed)) return COACH_TITRE
  if (/^coach\s+sportif$/i.test(trimmed)) return COACH_TITRE
  return trimmed.replace(/coaching/gi, 'Coach')
}
